module.exports = __webpack_public_path__ + "img/@team_img_04.ca44a8e8.jpg";